import React, { useCallback, useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "./Sidebar";
import RightSidebar from "./RightSidebar";
import {
  Backdrop,
  Box,
  Button,
  Paper,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  IconButton,
  CircularProgress,
} from "@mui/material";
import theme from "../../theme";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { BASE_URL, FILE_CATEGORY } from "../../Constants/Constants";
import { useDropzone } from "react-dropzone";
import { toast, ToastContainer } from "react-toastify";
import CustomLoader from "../../utils/CustomLoader";
import SectionLoader from "../../utils/SectionLoader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getToken } from "../../utils/utils";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import {
  FETCH_ERROR,
  FILE_UPLOAD_ERROR_MESSAGE,
  FILE_UPLOAD_SUCCESS_MESSAGE,
  FILE_UPLOAD_REQUIRED_MESSAGE,
} from "../../utils/Validation";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((themes) => ({
  MainContainer: {
    display: "flex",
    width: "100%",
    background: "#F1F1F1",
  },
  DashboardContainer: {
    background: theme.palette.secondary.main,
    height: "93vh",
    width: "60%",
    padding: 20,
    overflow: "auto",
  },
  TopHeader: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  Breadcrumbs: {
    display: "flex",
    gap: 4,
  },
  BreadcrumbsText: {
    color: theme.palette.secondary.black,
    fontFamily: "Helvetica",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "30px",
  },
  BreadcrumbsIcon: {
    width: "24px",
    height: "24px",
  },
  button: {
    marginTop: "20px !important",
    width: "200px !important",
    textTransform: "capitalize !important",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  AnalysisContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "98%",
  },
  EditBtn: {
    background: theme.palette.secondary.main,
    border: "none !important",
  },
}));

const Analysis = {
  signing_the_contract: "signing_the_contract",
  validity: "validity",
  extension: "extension",
  renewal: "renewal",
  annual_adjustment: "annual_adjustment",
  subcontracting: "subcontracting",
};
const C2Analysis = {
  subscription_of_the_contract: "subscription_of_the_contract",
  validity: "validity",
  renewal: "renewal",
  extension: "extension",
  subcontracting: "subcontracting",
  re_adjustability: "re_adjustability",
  price: "price",
  intellectual_property: "intellectual_property",
  deadlines: "deadlines",
};

const C3Analysis = {
  renewal: "renewal",
  extension: "extension",
  re_adjustability: "re_adjustability",
  subcontracting: "subcontracting",
  price: "price",
  intellectual_property: "intellectual_property",
  deadlines: "deadlines",
};

const Comments = {
  budget_available: "budget_available",
  guarantee_of_seriousness_offer: "guarantee_of_seriousness_offer",
  guarantee_of_faithful_compliance: "guarantee_of_faithful_compliance",
  fines: "fines",
  early_termination: "early_termination",
  pay: "pay",
};

const C2Comments = {
  estimated_contract_amount: "estimated_contract_amount",
  guarantees: "guarantees",
  offer_validity: "offer_validity",
  scope: "scope",
  evaluation_criteria: "evaluation_criteria",
  termination_of_contract: "termination_of_contract",
  confidentiality: "confidentiality",
  payment_term: "payment_term",
  budget_modification: "budget_modification",
  fines: "fines",
  presentation_of_warranty: "presentation_of_warranty",
  extension_of_the_contract_term: "extension_of_the_contract_term",
  early_termination: "early_termination",
  outsourcing: "outsourcing",
  method_of_payment: "method_of_payment",
  information_security: "information_security",
  ownership_of_information: "ownership_of_information",
};

const C3Comments = {
  guarantee_of_seriousness_offer: "guarantee_of_seriousness_offer",
  offer_validity: "offer_validity",
  scope: "scope",
  termination_of_contract: "termination_of_contract",
  confidentiality: "confidentiality",
  payment_term: "payment_term",
  fines: "fines",
  extension_of_the_contract_term: "extension_of_the_contract_term",
  early_termination: "early_termination",
  outsourcing: "outsourcing",
  method_of_payment: "method_of_payment",
  information_security: "information_security",
  ownership_of_information: "ownership_of_information",
};

const TechnicalComments = {
  applicable_standards: "applicable_standards",
  required_resources: "required_resources",
  trainings: "trainings",
  average_monthly_consumption: "average_monthly_consumption",
  emergency_service: "emergency_service",
  corrective_maintenance: "corrective_maintenance",
};

const C2TechnicalComments = {
  technical_requirements: "technical_requirements",
  training_plan: "training_plan",
  maintenance: "maintenance",
  execution_deadlines: "execution_deadlines",
  staff_required: "staff_required",
};

const C3TechnicalComments = {
  technical_requirements: "technical_requirements",
  maintenance: "maintenance",
  execution_deadlines: "execution_deadlines",
  staff_required: "staff_required",
};

const MetaDataObj = {
  document_for_customer: "document_for_customer",
  document_of: "document_of",
  document_date: "document_date",
  document_reference: "document_reference",
};

const itServiceDocument = {
  document_for_customer: "document_for_customer",
  document_of: "document_of",
  document_date: "document_date",
  document_reference: "document_reference",
  document_introduction: "document_introduction",
};

const itServiceComments = {
  comments_subscription_of_the_contract: "Subscription of the contract",
  comments_validity: "Validity",
  comments_renewal: "Renewal",
  comments_extension: "Extension",
  comments_subcontracting: "Subcontracting",
  comments_re_adjustability: "Re-adjustability",
  comments_price: "Price",
  comments_intellectual_property: "Intellectual Property",
  comments_deadlines: "Deadlines",
};

const itServiceAdministartiveBasis = {
  administrative_bases_estimated_contract_amount: "Estimated contract amount",
  administrative_bases_guarantees: "Guarantees",
  administrative_bases_offer_validity: "Offer validity",
  administrative_bases_scope: "Scope",
  administrative_bases_evaluation_criteria: "Evaluation criteria",
  administrative_bases_termination_of_contract: "Termination of contract",
  administrative_bases_confidentiality: "Confidentiality",
  administrative_bases_payment_term: "Payment term",
  administrative_bases_budget_modification: "Budget modification",
  administrative_bases_fines: "Fines",
  administrative_bases_presentation_of_warranty: "Presentation of warranty",
  administrative_bases_extension_of_the_contract_term:
    "Extension of the contract term",
  administrative_bases_early_termination: "Early termination",
  administrative_bases_outsourcing: "Outsourcing",
  administrative_bases_method_of_payment: "Method of payment",
  administrative_bases_information_security: "Information security",
  administrative_bases_ownership_of_information: "Ownership of information",
};

const itServicesTechnical = {
  technical_bases_technical_requirements: "Technical requirements",
  technical_bases_training_plan: "Training plan",
  technical_bases_maintenance: "Maintenance",
  technical_bases_execution_deadlines: "Execution deadlines",
  technical_bases_staff_required: "Staff required",
};

// Define the refreshable fields per category and section
const REFRESHABLE_FIELDS = {
  metadata: {
    all: ["document_for_customer", "document_reference"],
  },
  analysis: {
    [FILE_CATEGORY.distribution]: [
      "signing_the_contract",
      "validity",
      "extension",
      "renewal",
      "annual_adjustment",
      "subcontracting",
    ],
    [FILE_CATEGORY.it]: [
      "subscription_of_the_contract",
      "validity",
      "renewal",
      "extension",
      "subcontracting",
      "re_adjustability",
      "price",
      "intellectual_property",
      "deadlines",
    ],
    [FILE_CATEGORY.general]: [
      "renewal",
      "extension",
      "subcontracting",
      "re_adjustability",
      "price",
      "intellectual_property",
      "deadlines",
    ],
  },
  comments: {
    [FILE_CATEGORY.distribution]: [
      "budget_available",
      "guarantee_of_seriousness_offer",
      "guarantee_of_faithful_compliance",
      "fines",
      "early_termination",
      "pay",
    ],
    [FILE_CATEGORY.it]: [
      "estimated_contract_amount",
      "guarantees",
      "offer_validity",
      "scope",
      "evaluation_criteria",
      "termination_of_contract",
      "confidentiality",
      "payment_term",
      "budget_modification",
      "fines",
      "presentation_of_warranty",
      "extension_of_the_contract_term",
      "early_termination",
      "outsourcing",
      "method_of_payment",
      "information_security",
      "ownership_of_information",
    ],
    [FILE_CATEGORY.general]: [
      "guarantee_of_seriousness_offer",
      "offer_validity",
      "scope",
      "termination_of_contract",
      "confidentiality",
      "payment_term",
      "fines",
      "extension_of_the_contract_term",
      "early_termination",
      "outsourcing",
      "method_of_payment",
      "information_security",
      "ownership_of_information",
    ],
  },
  technical_comments: {
    [FILE_CATEGORY.distribution]: [
      "applicable_standards",
      "required_resources",
      "trainings",
      "average_monthly_consumption",
      "emergency_service",
      "corrective_maintenance",
    ],
    [FILE_CATEGORY.it]: [
      "technical_requirements",
      "training_plan",
      "maintenance",
      "execution_deadlines",
      "staff_required",
    ],
    [FILE_CATEGORY.general]: [
      "technical_requirements",
      "maintenance",
      "execution_deadlines",
      "staff_required",
    ],
  },
};

const Dashboard = () => {
  const classes = useStyles();
  const [UploadFileID, setUploadFileID] = useState("");
  const [uploadFileName, setUploadFileName] = useState([]);
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState(null);
  const [AnalysisData, setAnalysisData] = useState(null);
  const [commentsData, setCommentsData] = useState(null);
  const [technicalCommentsData, setTechnicalCommentsData] = useState(null);
  const [metaData, setMetaData] = useState(null);
  const [summaryData, setSummaryData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isAnalyze, setIsAnalyze] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [isEdit, setIsEdit] = useState("");
  const [saveDocumentID, setSaveDocumentID] = useState("");
  const [loadingStates, setLoadingStates] = useState({
    analysisData: false,
    commentsData: false,
    summaryData: false,
    technicalComments: false,
    metaData: false,
  });
  const [refreshingFields, setRefreshingFields] = useState({});
  const token = getToken();
  const location = useLocation();
  const matchData = location.state?.matchData;
  const { t } = useTranslation();
  useEffect(() => {
    if (matchData === undefined) {
      return;
    }
    if (matchData && matchData.category === FILE_CATEGORY.it) {
      const {
        file_id,
        document_for_customer,
        document_id,
        document_of,
        document_date,
        document_reference,
        document_introduction,
        document_summary,
        comments_subscription_of_the_contract,
        comments_validity,
        comments_re_adjustability,
        comments_deadlines,
        comments_extension,
        comments_renewal,
        comments_subcontracting,
        comments_intellectual_property,
        comments_price,
        administrative_bases_offer_validity,
        administrative_bases_guarantees,
        administrative_bases_scope,
        administrative_bases_termination_of_contract,
        administrative_bases_confidentiality,
        administrative_bases_payment_term,
        administrative_bases_fines,
        administrative_bases_extension_of_the_contract_term,
        administrative_bases_early_termination,
        administrative_bases_outsourcing,
        administrative_bases_method_of_payment,
        administrative_bases_information_security,
        administrative_bases_ownership_of_information,
        administrative_bases_estimated_contract_amount,
        administrative_bases_budget_modification,
        administrative_bases_presentation_of_warranty,
        administrative_bases_evaluation_criteria,
        technical_bases_training_plan,
        technical_bases_technical_requirements,
        technical_bases_maintenance,
        technical_bases_execution_deadlines,
        technical_bases_staff_required,
      } = matchData;
      setUploadFileID(file_id);
      setSaveDocumentID(document_id);
      setCategory(FILE_CATEGORY.it);
      setMetaData({
        data: {
          document_for_customer,
          document_of,
          document_date,
          document_reference,
        },
      });

      setSubCategory({
        category: matchData.category,
        introduction: document_introduction,
      });

      setSummaryData({ data: document_summary });

      setAnalysisData({
        analysis: {
          subscription_of_the_contract: comments_subscription_of_the_contract,
          validity: comments_validity,
          re_adjustability: comments_re_adjustability,
          deadlines: comments_deadlines,
          extension: comments_extension,
          renewal: comments_renewal,
          subcontracting: comments_subcontracting,
          intellectual_property: comments_intellectual_property,
          price: comments_price,
        },
      });

      setCommentsData({
        offer_validity: administrative_bases_offer_validity,
        guarantees: administrative_bases_guarantees,
        scope: administrative_bases_scope,
        termination_of_contract: administrative_bases_termination_of_contract,
        confidentiality: administrative_bases_confidentiality,
        payment_term: administrative_bases_payment_term,
        fines: administrative_bases_fines,
        extension_of_the_contract_term:
          administrative_bases_extension_of_the_contract_term,
        early_termination: administrative_bases_early_termination,
        outsourcing: administrative_bases_outsourcing,
        method_of_payment: administrative_bases_method_of_payment,
        information_security: administrative_bases_information_security,
        ownership_of_information: administrative_bases_ownership_of_information,
        estimated_contract_amount:
          administrative_bases_estimated_contract_amount,
        budget_modification: administrative_bases_budget_modification,
        presentation_of_warranty: administrative_bases_presentation_of_warranty,
        evaluation_criteria: administrative_bases_evaluation_criteria,
      });

      setTechnicalCommentsData({
        data: {
          training_plan: technical_bases_training_plan,
          technical_requirements: technical_bases_technical_requirements,
          maintenance: technical_bases_maintenance,
          execution_deadlines: technical_bases_execution_deadlines,
          staff_required: technical_bases_staff_required,
        },
      });
    } else if (matchData && matchData.category === FILE_CATEGORY.distribution) {
      const {
        file_id,
        document_for_customer,
        document_id,
        document_of,
        document_date,
        document_reference,
        document_introduction,
        document_summary,
        comments_signing_the_contract,
        comments_validity,
        comments_extension,
        comments_renewal,
        comments_annual_adjustment,
        comments_subcontracting,
        administrative_basis_budget_available,
        administrative_basis_guarantee_of_seriousness_offer,
        administrative_basis_guarantee_of_faithful_compliance,
        administrative_basis_fines,
        administrative_basis_early_termination,
        administrative_basis_pay,
        technical_basis_applicable_standards,
        technical_basis_required_resources,
        technical_basis_trainings,
        technical_basis_average_monthly_consumption,
        technical_basis_emergency_service,
        technical_basis_corrective_maintenance,
        technical_basis_additional_obligations,
      } = matchData;
      setUploadFileID(file_id);
      setSaveDocumentID(document_id);
      setCategory(FILE_CATEGORY.distribution);
      setMetaData({
        data: {
          document_for_customer,
          document_of,
          document_date,
          document_reference,
        },
      });

      setSubCategory({
        category: matchData.category,
        introduction: document_introduction,
      });

      setSummaryData({ data: document_summary });

      setAnalysisData({
        analysis: {
          signing_the_contract: comments_signing_the_contract,
          validity: comments_validity,
          extension: comments_extension,
          renewal: comments_renewal,
          annual_adjustment: comments_annual_adjustment,
          subcontracting: comments_subcontracting,
        },
      });

      setCommentsData({
        budget_available: administrative_basis_budget_available,
        guarantee_of_seriousness_offer:
          administrative_basis_guarantee_of_seriousness_offer,
        guarantee_of_faithful_compliance:
          administrative_basis_guarantee_of_faithful_compliance,
        fines: administrative_basis_fines,
        early_termination: administrative_basis_early_termination,
        pay: administrative_basis_pay,
      });

      setTechnicalCommentsData({
        data: {
          applicable_standards: technical_basis_applicable_standards,
          required_resources: technical_basis_required_resources,
          trainings: technical_basis_trainings,
          average_monthly_consumption:
            technical_basis_average_monthly_consumption,
          emergency_service: technical_basis_emergency_service,
          corrective_maintenance: technical_basis_corrective_maintenance,
          technical_basis_additional_obligations:
            technical_basis_additional_obligations,
        },
      });
    } else {
      const {
        file_id,
        document_for_customer,
        document_of,
        document_id,
        document_date,
        document_reference,
        document_introduction,
        document_summary,
        comments_renewal,
        comments_extension,
        comments_subcontracting,
        comments_re_adjustability,
        comments_price,
        comments_intellectual_property,
        comments_deadlines,
        administrative_basis_guarantee_of_seriousness_offer,
        administrative_bases_offer_validity,
        administrative_bases_scope,
        administrative_bases_termination_of_contract,
        administrative_bases_confidentiality,
        administrative_bases_payment_term,
        administrative_bases_fines,
        administrative_bases_extension_of_the_contract_term,
        administrative_bases_early_termination,
        administrative_bases_outsourcing,
        administrative_bases_method_of_payment,
        administrative_bases_information_security,
        administrative_bases_ownership_of_information,
        technical_bases_technical_requirements,
        technical_bases_maintenance,
        technical_bases_execution_deadlines,
        technical_bases_staff_required,
      } = matchData;
      setUploadFileID(file_id);
      setSaveDocumentID(document_id);
      setCategory(FILE_CATEGORY.general);
      setMetaData({
        data: {
          document_for_customer,
          document_of,
          document_date,
          document_reference,
        },
      });

      setSubCategory({
        category: matchData.category,
        introduction: document_introduction,
      });

      setSummaryData({ data: document_summary });
      setAnalysisData({
        analysis: {
          [C3Analysis.renewal]: comments_renewal || null,
          [C3Analysis.extension]: comments_extension || null,
          [C3Analysis.re_adjustability]: comments_re_adjustability || null,
          [C3Analysis.subcontracting]: comments_subcontracting || null,
          [C3Analysis.price]: comments_price || null,
          [C3Analysis.intellectual_property]:
            comments_intellectual_property || null,
          [C3Analysis.deadlines]: comments_deadlines || null,
        },
      });

      setCommentsData({
        [C3Comments.guarantee_of_seriousness_offer]:
          administrative_basis_guarantee_of_seriousness_offer || null,
        [C3Comments.offer_validity]:
          administrative_bases_offer_validity || null,
        [C3Comments.scope]: administrative_bases_scope || null,
        [C3Comments.termination_of_contract]:
          administrative_bases_termination_of_contract || null,
        [C3Comments.confidentiality]:
          administrative_bases_confidentiality || null,
        [C3Comments.payment_term]: administrative_bases_payment_term || null,
        [C3Comments.fines]: administrative_bases_fines || null,
        [C3Comments.extension_of_the_contract_term]:
          administrative_bases_extension_of_the_contract_term || null,
        [C3Comments.early_termination]:
          administrative_bases_early_termination || null,
        [C3Comments.outsourcing]: administrative_bases_outsourcing || null,
        [C3Comments.method_of_payment]:
          administrative_bases_method_of_payment || null,
        [C3Comments.information_security]:
          administrative_bases_information_security || null,
        [C3Comments.ownership_of_information]:
          administrative_bases_ownership_of_information || null,
      });

      // Setting Technical Comments Data
      setTechnicalCommentsData({
        data: {
          [C3TechnicalComments.technical_requirements]:
            technical_bases_technical_requirements || null,
          [C3TechnicalComments.maintenance]:
            technical_bases_maintenance || null,
          [C3TechnicalComments.execution_deadlines]:
            technical_bases_execution_deadlines || null,
          [C3TechnicalComments.staff_required]:
            technical_bases_staff_required || null,
        },
      });
    }
  }, [matchData]);

  const getSubCategory = async () => {
    if (!UploadFileID) {
      toast.error(FILE_UPLOAD_REQUIRED_MESSAGE);
      return;
    } else {
      let response = await fetchSubCategory();
      if (response?.data?.data) {
        setSubCategory(response?.data?.data);
        setCategory(response?.data?.data?.category);
        if (response?.data?.data?.category === FILE_CATEGORY.distribution) {
          try {
            // Set individual loading states to true
            setLoadingStates({
              analysisData: true,
              commentsData: true,
              summaryData: true,
              technicalComments: true,
              metaData: true,
            });

            // Execute fetch operations in parallel
            await Promise.all([
              fetchAnalysisData(FILE_CATEGORY.distribution).finally(() =>
                setLoadingStates((prev) => ({ ...prev, analysisData: false }))
              ),
              fetchCommentsData(FILE_CATEGORY.distribution).finally(() =>
                setLoadingStates((prev) => ({ ...prev, commentsData: false }))
              ),
              fetchSummaryData().finally(() =>
                setLoadingStates((prev) => ({ ...prev, summaryData: false }))
              ),
              fetchTechnicalComments(FILE_CATEGORY.distribution).finally(() =>
                setLoadingStates((prev) => ({
                  ...prev,
                  technicalComments: false,
                }))
              ),
              fetchMetaData().finally(() =>
                setLoadingStates((prev) => ({ ...prev, metaData: false }))
              ),
            ]);
          } catch (err) {
            toast.error(FETCH_ERROR);
          } finally {
            setIsAnalyze(false);
          }
        } else if (response?.data?.data?.category === FILE_CATEGORY.it) {
          try {
            // Set individual loading states to true
            setLoadingStates({
              analysisData: true,
              commentsData: true,
              summaryData: true,
              technicalComments: true,
              metaData: true,
            });

            // Execute fetch operations in parallel
            await Promise.all([
              fetchMetaData().finally(() =>
                setLoadingStates((prev) => ({ ...prev, metaData: false }))
              ),
              fetchAnalysisData(FILE_CATEGORY.it).finally(() =>
                setLoadingStates((prev) => ({ ...prev, analysisData: false }))
              ),
              fetchCommentsData(FILE_CATEGORY.it).finally(() =>
                setLoadingStates((prev) => ({ ...prev, commentsData: false }))
              ),
              fetchSummaryData().finally(() =>
                setLoadingStates((prev) => ({ ...prev, summaryData: false }))
              ),
              fetchTechnicalComments(FILE_CATEGORY.it).finally(() =>
                setLoadingStates((prev) => ({
                  ...prev,
                  technicalComments: false,
                }))
              ),
            ]);
          } catch (err) {
            toast.error(FETCH_ERROR);
          }
        } else if (response?.data?.data?.category === FILE_CATEGORY.general) {
          try {
            // Set individual loading states to true
            setLoadingStates({
              analysisData: true,
              commentsData: true,
              summaryData: true,
              technicalComments: true,
              metaData: true,
            });

            // Execute fetch operations in parallel
            await Promise.all([
              fetchMetaData().finally(() =>
                setLoadingStates((prev) => ({ ...prev, metaData: false }))
              ),
              fetchAnalysisData(FILE_CATEGORY.general).finally(() =>
                setLoadingStates((prev) => ({ ...prev, analysisData: false }))
              ),
              fetchCommentsData(FILE_CATEGORY.general).finally(() =>
                setLoadingStates((prev) => ({ ...prev, commentsData: false }))
              ),
              fetchSummaryData().finally(() =>
                setLoadingStates((prev) => ({ ...prev, summaryData: false }))
              ),
              fetchTechnicalComments(FILE_CATEGORY.general).finally(() =>
                setLoadingStates((prev) => ({
                  ...prev,
                  technicalComments: false,
                }))
              ),
            ]);
          } catch (err) {
            toast.error(FETCH_ERROR);
          }
        }
      } else {
        toast.error(response?.data?.error);
      }
    }
  };

  // Data Fetcher Function for Distribution Starts
  const fetchSubCategory = useCallback(async () => {
    if (!UploadFileID) return;
    try {
      const response = await axios.get(`${BASE_URL}/open_document/category/`, {
        params: { file_id: UploadFileID },
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      toast.error(FETCH_ERROR);
    }
  }, [UploadFileID, token]);

  const fetchAnalysisData = useCallback(
    async (category) => {
      if (!UploadFileID) return;
      try {
        // Get only the refreshable fields based on category
        const refreshableFields = REFRESHABLE_FIELDS.analysis[category] || [];

        // Initialize an analysis object
        const analysisData = { analysis: {} };

        // Create a batch of promises for refreshable fields only
        const promises = refreshableFields.map(async (fieldName) => {
          let url;
          if (category === FILE_CATEGORY.it) {
            url = `${BASE_URL}/field-extraction/c2-analysis/${fieldName}/`;
          } else if (category === FILE_CATEGORY.distribution) {
            url = `${BASE_URL}/field-extraction/analysis/${fieldName}/`;
          } else {
            url = `${BASE_URL}/field-extraction/c3-analysis/${fieldName}/`;
          }

          try {
            const response = await axios.get(url, {
              params: { file_id: UploadFileID },
              headers: { Authorization: `Bearer ${token}` },
            });

            if (
              response.data?.data?.analysis &&
              response.data.data.analysis[fieldName] !== undefined
            ) {
              analysisData.analysis[fieldName] =
                response.data.data.analysis[fieldName];
            } else {
              analysisData.analysis[fieldName] = null;
            }
          } catch (error) {
            console.error(`Error fetching ${fieldName}:`, error);
            analysisData.analysis[fieldName] = null;
          }
        });

        // Wait for all requests to complete
        await Promise.all(promises);

        // Set the analysis data
        setAnalysisData(analysisData);
      } catch (error) {
        toast.error(FETCH_ERROR);
      }
    },
    [UploadFileID, token]
  );

  const fetchCommentsData = useCallback(
    async (category) => {
      if (!UploadFileID) return;
      try {
        // Get only the refreshable fields based on category
        const refreshableFields = REFRESHABLE_FIELDS.comments[category] || [];

        // Initialize a comments object
        const commentsData = {};

        // Create a batch of promises for refreshable fields only
        const promises = refreshableFields.map(async (fieldName) => {
          let url;
          if (category === FILE_CATEGORY.it) {
            url = `${BASE_URL}/field-extraction/c2-comments/${fieldName}/`;
          } else if (category === FILE_CATEGORY.distribution) {
            url = `${BASE_URL}/field-extraction/comments/${fieldName}/`;
          } else {
            url = `${BASE_URL}/field-extraction/c3-comments/${fieldName}/`;
          }

          try {
            const response = await axios.get(url, {
              params: { file_id: UploadFileID },
              headers: { Authorization: `Bearer ${token}` },
            });

            if (
              response.data?.data?.comments &&
              response.data.data.comments[fieldName] !== undefined
            ) {
              commentsData[fieldName] = response.data.data.comments[fieldName];
            } else {
              commentsData[fieldName] = null;
            }
          } catch (error) {
            console.error(`Error fetching ${fieldName}:`, error);
            commentsData[fieldName] = null;
          }
        });

        // Wait for all requests to complete
        await Promise.all(promises);

        // Set the comments data
        setCommentsData(commentsData);
      } catch (error) {
        toast.error(FETCH_ERROR);
      }
    },
    [UploadFileID, token]
  );

  const fetchTechnicalComments = useCallback(
    async (category) => {
      if (!UploadFileID) return;
      try {
        // Get only the refreshable fields based on category
        const refreshableFields =
          REFRESHABLE_FIELDS.technical_comments[category] || [];

        // Initialize a technical comments object
        const technicalData = { data: {} };

        // Create a batch of promises for refreshable fields only
        const promises = refreshableFields.map(async (fieldName) => {
          let url;
          if (category === FILE_CATEGORY.it) {
            url = `${BASE_URL}/field-extraction/c2-technical-comments/${fieldName}/`;
          } else if (category === FILE_CATEGORY.distribution) {
            url = `${BASE_URL}/field-extraction/technical-comments/${fieldName}/`;
          } else {
            url = `${BASE_URL}/field-extraction/c3-technical-comments/${fieldName}/`;
          }

          try {
            const response = await axios.get(url, {
              params: { file_id: UploadFileID },
              headers: { Authorization: `Bearer ${token}` },
            });

            if (
              response.data?.data?.technical_comments &&
              response.data.data.technical_comments[fieldName] !== undefined
            ) {
              technicalData.data[fieldName] =
                response.data.data.technical_comments[fieldName];
            } else {
              technicalData.data[fieldName] = null;
            }
          } catch (error) {
            console.error(`Error fetching ${fieldName}:`, error);
            technicalData.data[fieldName] = null;
          }
        });

        // Wait for all requests to complete
        await Promise.all(promises);

        // Set the technical comments data
        setTechnicalCommentsData(technicalData);
      } catch (error) {
        toast.error(FETCH_ERROR);
      }
    },
    [UploadFileID, token]
  );

  const fetchMetaData = useCallback(async () => {
    if (!UploadFileID) return;
    try {
      const response = await axios.get(`${BASE_URL}/open_document/metadata/`, {
        params: { file_id: UploadFileID },
        headers: { Authorization: `Bearer ${token}` },
      });
      const additionalData = {
        document_of: "document-processor-react",
        document_date: new Date().toISOString().split("T")[0],
      };

      const mergedData = {
        data: {
          ...response.data.data,
          ...additionalData,
        },
      };
      setMetaData(mergedData);
    } catch (error) {
      toast.error(FETCH_ERROR);
    }
  }, [UploadFileID, token]);

  const fetchSummaryData = useCallback(async () => {
    if (!UploadFileID) return;
    try {
      const response = await axios.get(`${BASE_URL}/open_document/summary/`, {
        params: { file_id: UploadFileID },
        headers: { Authorization: `Bearer ${token}` },
      });
      setSummaryData(response.data);
    } catch (error) {
      toast.error(FETCH_ERROR);
    }
  }, [UploadFileID, token]);

  const onDrop = useCallback(
    async (acceptedFiles) => {
      setIsLoading(true);
      const file = acceptedFiles[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        try {
          const response = await axios.post(
            `${BASE_URL}/open_document/upload/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          setUploadFileID(response.data.file_id);
          setUploadFileName(response.data.filename);
          toast.success(FILE_UPLOAD_SUCCESS_MESSAGE);
        } catch (error) {
          toast.error(FILE_UPLOAD_ERROR_MESSAGE);
        } finally {
          setIsLoading(false);
        }
      }
    },
    [token]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    onDrop,
  });

  const stripIdFromFilename = (filename) => {
    const idPattern = new RegExp(`^${UploadFileID}-`);
    let newFilename = filename.replace(idPattern, "");

    const yearPattern = new RegExp(`^202[0-9]_`);
    newFilename = newFilename.replace(yearPattern, "");

    return newFilename;
  };

  const handleAnalysisChange = (key, value) => {
    setAnalysisData((prevState) => ({
      ...prevState,
      analysis: {
        ...prevState.analysis,
        [key]: value,
      },
    }));
  };
  const handleTechnicalCommentsChange = (key, value) => {
    setTechnicalCommentsData((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        [key]: value,
      },
    }));
  };
  const handleMetaDataChange = (key, value) => {
    setMetaData((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        [key]: value,
      },
    }));
  };
  const handleCommentsChange = (key, value) => {
    setCommentsData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleAccordionToggle = (key) => {
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [key]: !prevExpanded[key],
    }));
  };

  const handleEditButtonClick = (key) => {
    setIsEdit(key);
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [key]: true,
    }));
  };

  const handleSaveDocument = async () => {
    let bodyData;

    if (category === FILE_CATEGORY.general) {
      bodyData = {
        ...metaData.data,
        file_id: UploadFileID,
        document_introduction: Array.isArray(subCategory?.introduction)
          ? subCategory.introduction.join("")
          : subCategory?.introduction || "",
        document_summary: summaryData.data,

        comments_re_adjustability: AnalysisData.analysis.re_adjustability,
        comments_deadlines: AnalysisData.analysis.deadlines,
        comments_extension: AnalysisData.analysis.extension,
        comments_renewal: AnalysisData.analysis.renewal,
        comments_subcontracting: AnalysisData.analysis.subcontracting,
        comments_intellectual_property:
          AnalysisData.analysis.intellectual_property,
        comments_price: AnalysisData.analysis.price,

        administrative_bases_offer_validity: commentsData.offer_validity,
        administrative_basis_guarantee_of_seriousness_offer:
          commentsData.guarantee_of_seriousness_offer,
        administrative_bases_scope: commentsData.scope,
        administrative_bases_termination_of_contract:
          commentsData.termination_of_contract,
        administrative_bases_confidentiality: commentsData.confidentiality,
        administrative_bases_payment_term: commentsData.payment_term,
        administrative_bases_fines: commentsData.fines,
        administrative_bases_extension_of_the_contract_term:
          commentsData.extension_of_the_contract_term,
        administrative_bases_early_termination: commentsData.early_termination,
        administrative_bases_outsourcing: commentsData.outsourcing,
        administrative_bases_method_of_payment: commentsData.method_of_payment,
        administrative_bases_information_security:
          commentsData.information_security,
        administrative_bases_ownership_of_information:
          commentsData.ownership_of_information,

        technical_bases_technical_requirements:
          technicalCommentsData.data.technical_requirements,
        technical_bases_maintenance: technicalCommentsData.data.maintenance,
        technical_bases_execution_deadlines:
          technicalCommentsData.data.execution_deadlines,
        technical_bases_staff_required:
          technicalCommentsData.data.staff_required,
      };
    } else if (category === FILE_CATEGORY.distribution) {
      bodyData = {
        ...metaData.data,
        file_id: UploadFileID,
        document_introduction: Array.isArray(subCategory?.introduction)
          ? subCategory.introduction.join("")
          : subCategory?.introduction || "",
        document_summary: summaryData.data,
        comments_signing_the_contract:
          AnalysisData.analysis.signing_the_contract,
        comments_validity: AnalysisData.analysis.validity,
        comments_extension: AnalysisData.analysis.extension,
        comments_renewal: AnalysisData.analysis.renewal,
        comments_annual_adjustment: AnalysisData.analysis.annual_adjustment,
        comments_subcontracting: AnalysisData.analysis.subcontracting,
        administrative_basis_budget_available: commentsData.budget_available,
        administrative_basis_guarantee_of_seriousness_offer:
          commentsData.guarantee_of_seriousness_offer,
        administrative_basis_guarantee_of_faithful_compliance:
          commentsData.guarantee_of_faithful_compliance,
        administrative_basis_fines: commentsData.fines,
        administrative_basis_early_termination: commentsData.early_termination,
        administrative_basis_pay: commentsData.pay,
        technical_basis_applicable_standards:
          technicalCommentsData.data.applicable_standards,
        technical_basis_required_resources:
          technicalCommentsData.data.required_resources,
        technical_basis_trainings: technicalCommentsData.data.trainings,
        technical_basis_average_monthly_consumption:
          technicalCommentsData.data.average_monthly_consumption,
        technical_basis_emergency_service:
          technicalCommentsData.data.emergency_service,
        technical_basis_corrective_maintenance:
          technicalCommentsData.data.corrective_maintenance,
        technical_basis_additional_obligations:
          technicalCommentsData.data.applicable_standards,
      };
    } else if (category === FILE_CATEGORY.it) {
      bodyData = {
        ...metaData.data,
        file_id: UploadFileID,
        document_introduction: Array.isArray(subCategory?.introduction)
          ? subCategory.introduction.join("")
          : subCategory?.introduction || "",
        document_summary: summaryData.data,

        comments_subscription_of_the_contract:
          AnalysisData.analysis.subscription_of_the_contract,
        comments_validity: AnalysisData.analysis.validity,
        comments_re_adjustability: AnalysisData.analysis.re_adjustability,
        comments_deadlines: AnalysisData.analysis.deadlines,
        comments_extension: AnalysisData.analysis.extension,
        comments_renewal: AnalysisData.analysis.renewal,
        comments_subcontracting: AnalysisData.analysis.subcontracting,
        comments_intellectual_property:
          AnalysisData.analysis.intellectual_property,
        comments_price: AnalysisData.analysis.price,

        administrative_bases_offer_validity: commentsData.offer_validity,
        administrative_basis_guarantee_of_seriousness_offer:
          commentsData.guarantees,
        administrative_bases_scope: commentsData.scope,
        administrative_bases_termination_of_contract:
          commentsData.termination_of_contract,
        administrative_bases_confidentiality: commentsData.confidentiality,
        administrative_bases_payment_term: commentsData.payment_term,
        administrative_bases_fines: commentsData.fines,
        administrative_bases_extension_of_the_contract_term:
          commentsData.extension_of_the_contract_term,
        administrative_bases_early_termination: commentsData.early_termination,
        administrative_bases_outsourcing: commentsData.outsourcing,
        administrative_bases_method_of_payment: commentsData.method_of_payment,
        administrative_bases_information_security:
          commentsData.information_security,
        administrative_bases_ownership_of_information:
          commentsData.ownership_of_information,
        administrative_bases_estimated_contract_amount:
          commentsData.estimated_contract_amount,
        administrative_bases_guarantees: commentsData.guarantees,
        administrative_bases_budget_modification:
          commentsData.budget_modification,
        administrative_bases_presentation_of_warranty:
          commentsData.presentation_of_warranty,
        administrative_bases_evaluation_criteria:
          commentsData.evaluation_criteria,
        technical_bases_training_plan: technicalCommentsData.data.training_plan,
        technical_bases_technical_requirements:
          technicalCommentsData.data.technical_requirements,
        technical_bases_maintenance: technicalCommentsData.data.maintenance,
        technical_bases_execution_deadlines:
          technicalCommentsData.data.execution_deadlines,
        technical_bases_staff_required:
          technicalCommentsData.data.staff_required,
      };
    }
    try {
      setIsAnalyze(true);
      let categorySegment;

      if (category === FILE_CATEGORY.it) {
        categorySegment = "c2";
      } else if (category === FILE_CATEGORY.distribution) {
        categorySegment = "c1";
      } else {
        categorySegment = "c3";
      }
      let response;
      if (saveDocumentID) {
        response = await axios.patch(
          `${BASE_URL}/directory/update/${categorySegment}/${saveDocumentID}/`,
          bodyData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else {
        response = await axios.post(
          `${BASE_URL}/directory/create/${categorySegment}/`,
          bodyData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSaveDocumentID(response.data.document_id);
      }

      toast.success(t("documentDetails.documentSavedSuccessfully"));
      getSaveDoc(response.data.document_id);
    } catch (error) {
      toast.error(FETCH_ERROR);
    } finally {
      setIsAnalyze(false);
    }
  };
  const getSaveDoc = async (ID) => {
    try {
      setIsAnalyze(true);
      let categorySegment;

      if (category === FILE_CATEGORY.it) {
        categorySegment = "c2";
      } else if (category === FILE_CATEGORY.distribution) {
        categorySegment = "c1";
      } else {
        categorySegment = "c3";
      }

      const response = await axios.get(
        `${BASE_URL}/directory/${categorySegment}/${ID}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = response.data;

      if (category === FILE_CATEGORY.it) {
        const {
          document_for_customer,
          document_of,
          document_date,
          document_reference,
          document_introduction,
          document_summary,
          comments_subscription_of_the_contract,
          comments_validity,
          comments_re_adjustability,
          comments_deadlines,
          comments_extension,
          comments_renewal,
          comments_subcontracting,
          comments_intellectual_property,
          comments_price,
          administrative_bases_offer_validity,
          administrative_bases_guarantees,
          administrative_bases_scope,
          administrative_bases_termination_of_contract,
          administrative_bases_confidentiality,
          administrative_bases_payment_term,
          administrative_bases_fines,
          administrative_bases_extension_of_the_contract_term,
          administrative_bases_early_termination,
          administrative_bases_outsourcing,
          administrative_bases_method_of_payment,
          administrative_bases_information_security,
          administrative_bases_ownership_of_information,
          administrative_bases_estimated_contract_amount,
          administrative_bases_budget_modification,
          administrative_bases_presentation_of_warranty,
          administrative_bases_evaluation_criteria,
          technical_bases_training_plan,
          technical_bases_technical_requirements,
          technical_bases_maintenance,
          technical_bases_execution_deadlines,
          technical_bases_staff_required,
        } = data;

        setMetaData({
          data: {
            document_for_customer,
            document_of,
            document_date,
            document_reference,
          },
        });

        setSubCategory({
          ...subCategory,
          introduction: document_introduction,
        });

        setSummaryData({ data: document_summary });

        setAnalysisData({
          analysis: {
            subscription_of_the_contract: comments_subscription_of_the_contract,
            validity: comments_validity,
            re_adjustability: comments_re_adjustability,
            deadlines: comments_deadlines,
            extension: comments_extension,
            renewal: comments_renewal,
            subcontracting: comments_subcontracting,
            intellectual_property: comments_intellectual_property,
            price: comments_price,
          },
        });

        setCommentsData({
          offer_validity: administrative_bases_offer_validity,
          guarantees: administrative_bases_guarantees,
          scope: administrative_bases_scope,
          termination_of_contract: administrative_bases_termination_of_contract,
          confidentiality: administrative_bases_confidentiality,
          payment_term: administrative_bases_payment_term,
          fines: administrative_bases_fines,
          extension_of_the_contract_term:
            administrative_bases_extension_of_the_contract_term,
          early_termination: administrative_bases_early_termination,
          outsourcing: administrative_bases_outsourcing,
          method_of_payment: administrative_bases_method_of_payment,
          information_security: administrative_bases_information_security,
          ownership_of_information:
            administrative_bases_ownership_of_information,
          estimated_contract_amount:
            administrative_bases_estimated_contract_amount,
          budget_modification: administrative_bases_budget_modification,
          presentation_of_warranty:
            administrative_bases_presentation_of_warranty,
          evaluation_criteria: administrative_bases_evaluation_criteria,
        });

        setTechnicalCommentsData({
          data: {
            training_plan: technical_bases_training_plan,
            technical_requirements: technical_bases_technical_requirements,
            maintenance: technical_bases_maintenance,
            execution_deadlines: technical_bases_execution_deadlines,
            staff_required: technical_bases_staff_required,
          },
        });
      } else if (category === FILE_CATEGORY.distribution) {
        const {
          document_for_customer,
          document_of,
          document_date,
          document_reference,
          document_introduction,
          document_summary,
          comments_signing_the_contract,
          comments_validity,
          comments_extension,
          comments_renewal,
          comments_annual_adjustment,
          comments_subcontracting,
          administrative_basis_budget_available,
          administrative_basis_guarantee_of_seriousness_offer,
          administrative_basis_guarantee_of_faithful_compliance,
          administrative_basis_fines,
          administrative_basis_early_termination,
          administrative_basis_pay,
          technical_basis_applicable_standards,
          technical_basis_required_resources,
          technical_basis_trainings,
          technical_basis_average_monthly_consumption,
          technical_basis_emergency_service,
          technical_basis_corrective_maintenance,
          technical_basis_additional_obligations,
        } = data;
        setMetaData({
          data: {
            document_for_customer,
            document_of,
            document_date,
            document_reference,
          },
        });

        setSubCategory({
          ...subCategory,
          introduction: document_introduction,
        });

        setSummaryData({ data: document_summary });

        setAnalysisData({
          analysis: {
            signing_the_contract: comments_signing_the_contract,
            validity: comments_validity,
            extension: comments_extension,
            renewal: comments_renewal,
            annual_adjustment: comments_annual_adjustment,
            subcontracting: comments_subcontracting,
          },
        });

        setCommentsData({
          budget_available: administrative_basis_budget_available,
          guarantee_of_seriousness_offer:
            administrative_basis_guarantee_of_seriousness_offer,
          guarantee_of_faithful_compliance:
            administrative_basis_guarantee_of_faithful_compliance,
          fines: administrative_basis_fines,
          early_termination: administrative_basis_early_termination,
          pay: administrative_basis_pay,
        });

        setTechnicalCommentsData({
          data: {
            applicable_standards: technical_basis_applicable_standards,
            required_resources: technical_basis_required_resources,
            trainings: technical_basis_trainings,
            average_monthly_consumption:
              technical_basis_average_monthly_consumption,
            emergency_service: technical_basis_emergency_service,
            corrective_maintenance: technical_basis_corrective_maintenance,
            technical_basis_additional_obligations:
              technical_basis_additional_obligations,
          },
        });
      } else {
        const {
          document_for_customer,
          document_of,
          document_date,
          document_reference,
          document_introduction,
          document_summary,
          comments_renewal,
          comments_extension,
          comments_subcontracting,
          comments_re_adjustability,
          comments_price,
          comments_intellectual_property,
          comments_deadlines,
          administrative_basis_guarantee_of_seriousness_offer,
          administrative_bases_offer_validity,
          administrative_bases_scope,
          administrative_bases_termination_of_contract,
          administrative_bases_confidentiality,
          administrative_bases_payment_term,
          administrative_bases_fines,
          administrative_bases_extension_of_the_contract_term,
          administrative_bases_early_termination,
          administrative_bases_outsourcing,
          administrative_bases_method_of_payment,
          administrative_bases_information_security,
          administrative_bases_ownership_of_information,
          technical_bases_technical_requirements,
          technical_bases_maintenance,
          technical_bases_execution_deadlines,
          technical_bases_staff_required,
        } = data;

        console.log("DATA", data);
        setMetaData({
          data: {
            document_for_customer,
            document_of,
            document_date,
            document_reference,
          },
        });

        setSubCategory({
          ...subCategory,
          introduction: document_introduction,
        });

        setSummaryData({ data: document_summary });
        setAnalysisData({
          analysis: {
            [C3Analysis.renewal]: comments_renewal || null,
            [C3Analysis.extension]: comments_extension || null,
            [C3Analysis.re_adjustability]: comments_re_adjustability || null,
            [C3Analysis.subcontracting]: comments_subcontracting || null,
            [C3Analysis.price]: comments_price || null,
            [C3Analysis.intellectual_property]:
              comments_intellectual_property || null,
            [C3Analysis.deadlines]: comments_deadlines || null,
          },
        });

        setCommentsData({
          [C3Comments.guarantee_of_seriousness_offer]:
            administrative_basis_guarantee_of_seriousness_offer || null,
          [C3Comments.offer_validity]:
            administrative_bases_offer_validity || null,
          [C3Comments.scope]: administrative_bases_scope || null,
          [C3Comments.termination_of_contract]:
            administrative_bases_termination_of_contract || null,
          [C3Comments.confidentiality]:
            administrative_bases_confidentiality || null,
          [C3Comments.payment_term]: administrative_bases_payment_term || null,
          [C3Comments.fines]: administrative_bases_fines || null,
          [C3Comments.extension_of_the_contract_term]:
            administrative_bases_extension_of_the_contract_term || null,
          [C3Comments.early_termination]:
            administrative_bases_early_termination || null,
          [C3Comments.outsourcing]: administrative_bases_outsourcing || null,
          [C3Comments.method_of_payment]:
            administrative_bases_method_of_payment || null,
          [C3Comments.information_security]:
            administrative_bases_information_security || null,
          [C3Comments.ownership_of_information]:
            administrative_bases_ownership_of_information || null,
        });

        // Setting Technical Comments Data
        setTechnicalCommentsData({
          data: {
            [C3TechnicalComments.technical_requirements]:
              technical_bases_technical_requirements || null,
            [C3TechnicalComments.maintenance]:
              technical_bases_maintenance || null,
            [C3TechnicalComments.execution_deadlines]:
              technical_bases_execution_deadlines || null,
            [C3TechnicalComments.staff_required]:
              technical_bases_staff_required || null,
          },
        });
      }
    } catch {
      toast.error(FETCH_ERROR);
    } finally {
      setIsAnalyze(false);
    }
  };
  const handleExportDocs = async () => {
    let url = "";

    if (saveDocumentID) {
      if (category === FILE_CATEGORY.distribution) {
        url = `${BASE_URL}/directory/export/${saveDocumentID}/`;
      } else if (category === FILE_CATEGORY.it) {
        url = `${BASE_URL}/directory/export/c2/${saveDocumentID}/`;
      } else if (category === FILE_CATEGORY.general) {
        url = `${BASE_URL}/directory/export/c3/${saveDocumentID}/`;
      }

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        const file = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(file);

        const fileName =
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "exported_file";

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
      } catch (err) {
        console.log(err);
        toast.error(FETCH_ERROR);
      }
    } else {
      toast.error("Something went wrong");
    }
  };

  const formatString = (input) => {
    // Metadata fields
    if (input === "document_for_customer")
      return t("documentDetails.documentForCustomer");
    if (input === "document_of") return t("documentDetails.documentOf");
    if (input === "document_date") return t("documentDetails.documentDate");
    if (input === "document_reference")
      return t("documentDetails.documentReference");

    // Analysis fields
    if (input === "signing_the_contract")
      return t("documentDetails.signingTheContract");
    if (input === "validity") return t("documentDetails.validity");
    if (input === "extension") return t("documentDetails.extension");
    if (input === "renewal") return t("documentDetails.renewal");
    if (input === "annual_adjustment")
      return t("documentDetails.annualAdjustment");
    if (input === "subcontracting") return t("documentDetails.subcontracting");
    if (input === "subscription_of_the_contract")
      return t("documentDetails.subscriptionOfTheContract");
    if (input === "re_adjustability")
      return t("documentDetails.reAdjustability");
    if (input === "price") return t("documentDetails.price");
    if (input === "intellectual_property")
      return t("documentDetails.intellectualProperty");
    if (input === "deadlines") return t("documentDetails.deadlines");

    // Comments fields
    if (input === "budget_available")
      return t("documentDetails.budgetAvailable");
    if (input === "guarantee_of_seriousness_offer")
      return t("documentDetails.guaranteeOfSeriousnessOffer");
    if (input === "guarantee_of_faithful_compliance")
      return t("documentDetails.guaranteeOfFaithfulCompliance");
    if (input === "fines") return t("documentDetails.fines");
    if (input === "early_termination")
      return t("documentDetails.earlyTermination");
    if (input === "pay") return t("documentDetails.pay");
    if (input === "estimated_contract_amount")
      return t("documentDetails.estimatedContractAmount");
    if (input === "guarantees") return t("documentDetails.guarantees");
    if (input === "offer_validity") return t("documentDetails.offerValidity");
    if (input === "scope") return t("documentDetails.scope");
    if (input === "evaluation_criteria")
      return t("documentDetails.evaluationCriteria");
    if (input === "termination_of_contract")
      return t("documentDetails.terminationOfContract");
    if (input === "confidentiality")
      return t("documentDetails.confidentiality");
    if (input === "payment_term") return t("documentDetails.paymentTerm");
    if (input === "budget_modification")
      return t("documentDetails.budgetModification");
    if (input === "presentation_of_warranty")
      return t("documentDetails.presentationOfWarranty");
    if (input === "extension_of_the_contract_term")
      return t("documentDetails.extensionOfTheContractTerm");
    if (input === "outsourcing") return t("documentDetails.outsourcing");
    if (input === "method_of_payment")
      return t("documentDetails.methodOfPayment");
    if (input === "information_security")
      return t("documentDetails.informationSecurity");
    if (input === "ownership_of_information")
      return t("documentDetails.ownershipOfInformation");

    // Technical Comments fields
    if (input === "applicable_standards")
      return t("documentDetails.applicableStandards");
    if (input === "required_resources")
      return t("documentDetails.requiredResources");
    if (input === "trainings") return t("documentDetails.trainings");
    if (input === "average_monthly_consumption")
      return t("documentDetails.averageMonthlyConsumption");
    if (input === "emergency_service")
      return t("documentDetails.emergencyService");
    if (input === "corrective_maintenance")
      return t("documentDetails.correctiveMaintenance");
    if (input === "technical_requirements")
      return t("documentDetails.technicalRequirements");
    if (input === "training_plan") return t("documentDetails.trainingPlan");
    if (input === "maintenance") return t("documentDetails.maintenance");
    if (input === "execution_deadlines")
      return t("documentDetails.executionDeadlines");
    if (input === "staff_required") return t("documentDetails.staffRequired");

    // Otherwise use the default formatting
    return input
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Function to check if a field is refreshable
  const isFieldRefreshable = (fieldName, section) => {
    if (section === "metadata") {
      return REFRESHABLE_FIELDS.metadata.all.includes(fieldName);
    } else if (
      section === "analysis" &&
      REFRESHABLE_FIELDS.analysis[category]
    ) {
      return REFRESHABLE_FIELDS.analysis[category].includes(fieldName);
    } else if (
      section === "comments" &&
      REFRESHABLE_FIELDS.comments[category]
    ) {
      return REFRESHABLE_FIELDS.comments[category].includes(fieldName);
    } else if (
      section === "technical_comments" &&
      REFRESHABLE_FIELDS.technical_comments[category]
    ) {
      return REFRESHABLE_FIELDS.technical_comments[category].includes(
        fieldName
      );
    }
    return false;
  };

  // Function to refresh a specific field
  const handleFieldRefresh = async (fieldName, section = "metadata") => {
    if (!UploadFileID) return;
    try {
      // Set loading state for this specific field
      setRefreshingFields((prev) => ({
        ...prev,
        [`${section}_${fieldName}`]: true,
      }));

      let url;
      // Determine the URL based on section and category
      if (section === "metadata") {
        url = `${BASE_URL}/field-extraction/metadata/${fieldName}/`;
      } else if (section === "analysis") {
        if (category === FILE_CATEGORY.it) {
          url = `${BASE_URL}/field-extraction/c2-analysis/${fieldName}/`;
        } else if (category === FILE_CATEGORY.distribution) {
          url = `${BASE_URL}/field-extraction/analysis/${fieldName}/`;
        } else {
          url = `${BASE_URL}/field-extraction/c3-analysis/${fieldName}/`;
        }
      } else if (section === "comments") {
        if (category === FILE_CATEGORY.it) {
          url = `${BASE_URL}/field-extraction/c2-comments/${fieldName}/`;
        } else if (category === FILE_CATEGORY.distribution) {
          url = `${BASE_URL}/field-extraction/comments/${fieldName}/`;
        } else {
          url = `${BASE_URL}/field-extraction/c3-comments/${fieldName}/`;
        }
      } else if (section === "technical_comments") {
        if (category === FILE_CATEGORY.it) {
          url = `${BASE_URL}/field-extraction/c2-technical-comments/${fieldName}/`;
        } else if (category === FILE_CATEGORY.distribution) {
          url = `${BASE_URL}/field-extraction/technical-comments/${fieldName}/`;
        } else {
          url = `${BASE_URL}/field-extraction/c3-technical-comments/${fieldName}/`;
        }
      }

      const response = await axios.get(url, {
        params: { file_id: UploadFileID },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data) {
        // Update the specific field based on the section
        switch (section) {
          case "metadata":
            setMetaData((prevState) => ({
              ...prevState,
              data: {
                ...prevState.data,
                [fieldName]: response.data.data.metadata[fieldName],
              },
            }));
            break;
          case "analysis":
            setAnalysisData((prevState) => ({
              ...prevState,
              analysis: {
                ...prevState.analysis,
                [fieldName]: response.data.data.analysis[fieldName],
              },
            }));
            break;
          case "comments":
            setCommentsData((prevState) => ({
              ...prevState,
              [fieldName]: response.data.data.comments[fieldName],
            }));
            break;
          case "technical_comments":
            setTechnicalCommentsData((prevState) => ({
              ...prevState,
              data: {
                ...prevState.data,
                [fieldName]: response.data.data.technical_comments[fieldName],
              },
            }));
            break;
          default:
            break;
        }
        toast.success(
          `${formatString(fieldName)} ${t("messages.refreshedSuccessfully")}`
        );
      }
    } catch (error) {
      toast.error(FETCH_ERROR);
    } finally {
      // Clear the loading state for this specific field
      setRefreshingFields((prev) => ({
        ...prev,
        [`${section}_${fieldName}`]: false,
      }));
    }
  };

  return (
    <>
      <Header />
      <Box className={classes.MainContainer}>
        <Sidebar />
        <Box className={classes.DashboardContainer}>
          <Box className={classes.TopHeader}>
            <Box className={classes.Breadcrumbs}>
              <Typography className={classes.BreadcrumbsText}>
                {t("dashboard.analyzeDocument")}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.ImportBtn} {...getRootProps()}>
            <input {...getInputProps()} />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={open}
            >
              {isLoading ? (
                <CustomLoader loading={isLoading} color="#fff" size={25} />
              ) : (
                <>{t("buttons.importDocument")}</>
              )}
            </Button>
          </Box>

          {/* details */}
          {(uploadFileName.length > 0 || subCategory || summaryData) && (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                "& > :not(style)": {
                  mt: 10,
                  width: "96%",
                  maxWidth: "100%",
                  minHeight: 128,
                  height: "auto",
                },
              }}
            >
              <Box>
                <Typography sx={{ py: 2 }} variant="h2">
                  {t("documentDetails.fileDetails")}
                </Typography>
                <Paper sx={{ padding: 2 }}>
                  {uploadFileName.length > 0 && (
                    <Typography variant="h6">
                      <span style={{ fontWeight: "bold" }}>
                        {t("documentDetails.filename")}:
                      </span>{" "}
                      {stripIdFromFilename(uploadFileName)}
                    </Typography>
                  )}
                  {subCategory && (
                    <>
                      <Typography variant="h6">
                        <span style={{ fontWeight: "bold" }}>
                          {t("documentDetails.category")}:
                        </span>{" "}
                        {subCategory?.category}
                      </Typography>
                      <Typography variant="h6">
                        <span style={{ fontWeight: "bold" }}>
                          {t("documentDetails.introduction")}:
                        </span>{" "}
                        {subCategory?.introduction}
                      </Typography>
                    </>
                  )}
                  {summaryData ? (
                    <Typography variant="h6">
                      <span style={{ fontWeight: "bold" }}>
                        {t("documentDetails.summary")}:
                      </span>{" "}
                      {summaryData.data}
                    </Typography>
                  ) : loadingStates.summaryData ? (
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        variant="h6"
                        component="span"
                        style={{ fontWeight: "bold" }}
                      >
                        {t("documentDetails.summary")}:
                      </Typography>{" "}
                      <SectionLoader size={16} />
                    </Box>
                  ) : null}
                </Paper>
              </Box>
            </Box>
          )}

          {/* Metadata Section */}
          {metaData || loadingStates.metaData ? (
            <Box sx={{ padding: "20px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ py: 2 }} variant="h2">
                  {t("documentDetails.metadata")}
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ width: "10px", height: "40px" }}
                  onClick={() => fetchMetaData()}
                  disabled={loadingStates.metaData}
                >
                  {loadingStates.metaData ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <RefreshIcon />
                  )}
                </Button>
              </Box>
              {Object.entries(MetaDataObj).map(([key, value]) => (
                <Accordion
                  key={key}
                  expanded={expanded[key] !== false}
                  onChange={() => handleAccordionToggle(key)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${key}-content`}
                    id={`${key}-header`}
                  >
                    <Box className={classes.AnalysisContainer}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        {formatString(key)}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {isFieldRefreshable(key, "metadata") && (
                          <IconButton
                            size="small"
                            sx={{
                              mr: 1,
                              color: theme.palette.primary.main,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFieldRefresh(key);
                            }}
                            disabled={
                              refreshingFields[`metadata_${key}`] ||
                              loadingStates.metaData
                            }
                          >
                            {refreshingFields[`metadata_${key}`] ? (
                              <CircularProgress size={16} />
                            ) : (
                              <RefreshIcon />
                            )}
                          </IconButton>
                        )}
                        {!isEdit || isEdit !== key ? (
                          <Button
                            className={classes.EditBtn}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditButtonClick(key);
                            }}
                            disabled={
                              refreshingFields[`metadata_${key}`] ||
                              loadingStates.metaData
                            }
                          >
                            {t("buttons.edit")}
                          </Button>
                        ) : (
                          <Button
                            color={"success"}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsEdit("");
                            }}
                          >
                            {t("buttons.save")}
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    {isEdit === key ? (
                      <TextField
                        sx={{ width: "100%" }}
                        multiline
                        rows={2}
                        variant="outlined"
                        color="info"
                        value={metaData ? metaData.data[key] : ""}
                        onChange={(e) =>
                          handleMetaDataChange(key, e.target.value)
                        }
                        disabled={loadingStates.metaData}
                      />
                    ) : refreshingFields[`metadata_${key}`] ? (
                      <Box display="flex" alignItems="center">
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                        <Typography variant="body2">Refreshing...</Typography>
                      </Box>
                    ) : loadingStates.metaData ? (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <CircularProgress size={20} />
                        <Typography variant="body2" sx={{ ml: 1 }}>
                          Loading data...
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>{metaData && metaData.data[key]}</Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          ) : null}

          {/* Analysis Section */}
          {(AnalysisData || loadingStates.analysisData) && category ? (
            <Box sx={{ padding: "20px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ py: 2 }} variant="h2">
                  {t("documentDetails.analysis")}
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ width: "10px", height: "40px" }}
                  onClick={() => fetchAnalysisData(category)}
                  disabled={loadingStates.analysisData}
                >
                  {loadingStates.analysisData ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <RefreshIcon />
                  )}
                </Button>
              </Box>
              {Object.entries(
                category === FILE_CATEGORY.distribution
                  ? Analysis
                  : category === FILE_CATEGORY.it
                  ? C2Analysis
                  : C3Analysis
              ).map(([key, value]) => (
                <Accordion
                  key={key}
                  expanded={expanded[key] !== false}
                  onChange={() => handleAccordionToggle(key)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${key}-content`}
                    id={`${key}-header`}
                  >
                    <Box className={classes.AnalysisContainer}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        {formatString(key)}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {isFieldRefreshable(key, "analysis") && (
                          <IconButton
                            size="small"
                            sx={{
                              mr: 1,
                              color: theme.palette.primary.main,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFieldRefresh(key, "analysis");
                            }}
                            disabled={
                              refreshingFields[`analysis_${key}`] ||
                              loadingStates.analysisData
                            }
                          >
                            {refreshingFields[`analysis_${key}`] ? (
                              <CircularProgress size={16} />
                            ) : (
                              <RefreshIcon />
                            )}
                          </IconButton>
                        )}
                        {!isEdit || isEdit !== key ? (
                          <Button
                            className={classes.EditBtn}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditButtonClick(key);
                            }}
                            disabled={
                              refreshingFields[`analysis_${key}`] ||
                              loadingStates.analysisData
                            }
                          >
                            {t("buttons.edit")}
                          </Button>
                        ) : (
                          <Button
                            color={"success"}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsEdit("");
                            }}
                          >
                            {t("buttons.save")}
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    {isEdit === key ? (
                      <TextField
                        sx={{ width: "100%" }}
                        multiline
                        rows={2}
                        variant="outlined"
                        color="info"
                        value={AnalysisData ? AnalysisData.analysis[key] : ""}
                        onChange={(e) =>
                          handleAnalysisChange(key, e.target.value)
                        }
                        disabled={loadingStates.analysisData}
                      />
                    ) : refreshingFields[`analysis_${key}`] ? (
                      <Box display="flex" alignItems="center">
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                        <Typography variant="body2">Refreshing...</Typography>
                      </Box>
                    ) : loadingStates.analysisData ? (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <CircularProgress size={20} />
                        <Typography variant="body2" sx={{ ml: 1 }}>
                          Loading data...
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>
                        {AnalysisData &&
                          (typeof AnalysisData.analysis[key] === "object"
                            ? JSON.stringify(AnalysisData.analysis[key])
                            : AnalysisData.analysis[key])}
                      </Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          ) : null}

          {/* Comments Section */}
          {(commentsData || loadingStates.commentsData) && category ? (
            <Box sx={{ padding: "20px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ py: 2 }} variant="h2">
                  {t("documentDetails.comments")}
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ width: "10px", height: "40px" }}
                  onClick={() => fetchCommentsData(category)}
                  disabled={loadingStates.commentsData}
                >
                  {loadingStates.commentsData ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <RefreshIcon />
                  )}
                </Button>
              </Box>
              {Object.entries(
                category === FILE_CATEGORY.distribution
                  ? Comments
                  : category === FILE_CATEGORY.it
                  ? C2Comments
                  : C3Comments
              ).map(([key, value]) => (
                <Accordion
                  key={key}
                  expanded={expanded[key] !== false}
                  onChange={() => handleAccordionToggle(key)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${key}-content`}
                    id={`${key}-header`}
                  >
                    <Box className={classes.AnalysisContainer}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        {formatString(key)}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {isFieldRefreshable(key, "comments") && (
                          <IconButton
                            size="small"
                            sx={{
                              mr: 1,
                              color: theme.palette.primary.main,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFieldRefresh(key, "comments");
                            }}
                            disabled={
                              refreshingFields[`comments_${key}`] ||
                              loadingStates.commentsData
                            }
                          >
                            {refreshingFields[`comments_${key}`] ? (
                              <CircularProgress size={16} />
                            ) : (
                              <RefreshIcon />
                            )}
                          </IconButton>
                        )}
                        {!isEdit || isEdit !== key ? (
                          <Button
                            className={classes.EditBtn}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditButtonClick(key);
                            }}
                            disabled={
                              refreshingFields[`comments_${key}`] ||
                              loadingStates.commentsData
                            }
                          >
                            {t("buttons.edit")}
                          </Button>
                        ) : (
                          <Button
                            color={"success"}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsEdit("");
                            }}
                          >
                            {t("buttons.save")}
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails>
                    {isEdit === key ? (
                      <TextField
                        sx={{ width: "100%" }}
                        multiline
                        rows={2}
                        variant="outlined"
                        color="info"
                        value={commentsData ? commentsData[key] : ""}
                        onChange={(e) =>
                          handleCommentsChange(key, e.target.value)
                        }
                        disabled={loadingStates.commentsData}
                      />
                    ) : refreshingFields[`comments_${key}`] ? (
                      <Box display="flex" alignItems="center">
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                        <Typography variant="body2">Refreshing...</Typography>
                      </Box>
                    ) : loadingStates.commentsData ? (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <CircularProgress size={20} />
                        <Typography variant="body2" sx={{ ml: 1 }}>
                          Loading data...
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>
                        {commentsData &&
                          (typeof commentsData[key] === "object"
                            ? JSON.stringify(commentsData[key])
                            : commentsData[key])}
                      </Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          ) : null}

          {/* Technical Comments Section */}
          {(technicalCommentsData || loadingStates.technicalComments) &&
          category ? (
            <Box sx={{ padding: "20px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ py: 2 }} variant="h2">
                  {t("documentDetails.technicalComments")}
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ width: "10px", height: "40px" }}
                  onClick={() => fetchTechnicalComments(category)}
                  disabled={loadingStates.technicalComments}
                >
                  {loadingStates.technicalComments ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <RefreshIcon />
                  )}
                </Button>
              </Box>
              {Object.entries(
                category === FILE_CATEGORY.distribution
                  ? TechnicalComments
                  : category === FILE_CATEGORY.it
                  ? C2TechnicalComments
                  : C3TechnicalComments
              ).map(([key, value]) => (
                <Accordion
                  key={key}
                  expanded={expanded[key] !== false}
                  onChange={() => handleAccordionToggle(key)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${key}-content`}
                    id={`${key}-header`}
                  >
                    <Box className={classes.AnalysisContainer}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        {formatString(key)}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {isFieldRefreshable(key, "technical_comments") && (
                          <IconButton
                            size="small"
                            sx={{
                              mr: 1,
                              color: theme.palette.primary.main,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFieldRefresh(key, "technical_comments");
                            }}
                            disabled={
                              refreshingFields[`technical_comments_${key}`] ||
                              loadingStates.technicalComments
                            }
                          >
                            {refreshingFields[`technical_comments_${key}`] ? (
                              <CircularProgress size={16} />
                            ) : (
                              <RefreshIcon />
                            )}
                          </IconButton>
                        )}
                        {!isEdit || isEdit !== key ? (
                          <Button
                            className={classes.EditBtn}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditButtonClick(key);
                            }}
                            disabled={
                              refreshingFields[`technical_comments_${key}`] ||
                              loadingStates.technicalComments
                            }
                          >
                            {t("buttons.edit")}
                          </Button>
                        ) : (
                          <Button
                            color={"success"}
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsEdit("");
                            }}
                          >
                            {t("buttons.save")}
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    {isEdit === key ? (
                      <TextField
                        sx={{ width: "100%" }}
                        multiline
                        rows={2}
                        variant="outlined"
                        color="info"
                        value={
                          technicalCommentsData
                            ? technicalCommentsData.data[key]
                            : ""
                        }
                        onChange={(e) =>
                          handleTechnicalCommentsChange(key, e.target.value)
                        }
                        disabled={loadingStates.technicalComments}
                      />
                    ) : refreshingFields[`technical_comments_${key}`] ? (
                      <Box display="flex" alignItems="center">
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                        <Typography variant="body2">Refreshing...</Typography>
                      </Box>
                    ) : loadingStates.technicalComments ? (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <CircularProgress size={20} />
                        <Typography variant="body2" sx={{ ml: 1 }}>
                          Loading data...
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>
                        {technicalCommentsData &&
                          (typeof technicalCommentsData.data[key] === "object"
                            ? JSON.stringify(technicalCommentsData.data[key])
                            : technicalCommentsData.data[key])}
                      </Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          ) : null}
          <Box className={classes.TopHeader}>
            <Box></Box>
            {metaData &&
              AnalysisData &&
              commentsData &&
              technicalCommentsData && (
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="success"
                  className={classes.button}
                  onClick={handleSaveDocument}
                  disabled={
                    isAnalyze ||
                    loadingStates.metaData ||
                    loadingStates.analysisData ||
                    loadingStates.commentsData ||
                    loadingStates.technicalComments ||
                    loadingStates.summaryData
                  }
                >
                  {isAnalyze ? (
                    <CustomLoader loading={true} color="#fff" size={25} />
                  ) : (
                    <>{t("buttons.saveDocument")}</>
                  )}
                </Button>
              )}
          </Box>
        </Box>
        <RightSidebar
          getSubCategory={getSubCategory}
          handleExportDocs={handleExportDocs}
          metaData={metaData}
        />
      </Box>
      <Backdrop className={classes.backdrop} open={isAnalyze}>
        <CustomLoader loading={isAnalyze} size={50} />
      </Backdrop>
      <ToastContainer />
    </>
  );
};

export default Dashboard;
